module.exports = __webpack_public_path__ + "img/liubov-ilchuk-746545-unsplash.5bfb3799.jpg";